import { Product } from 'schema-dts';
import { JsonLd } from './JsonLD';

function ProductSchema(props: { pageProps: any; locale?: string }) {
  const { pageProps } = props;
  const product: Product = {
    '@type': 'Product',
    name: pageProps?.layout?.title,
    image: 'https://www.nawy.com/assets/icons/common/nawy.svg',
    description: pageProps?.layout?.metaDescription,
    url: 'https://www.nawy.com/Real-Estate-Offers',
    offers: pageProps?.initialOffers
  };

  return JsonLd<Product>('product-schema', {
    '@context': 'https://schema.org',
    ...product
  });
}

export default ProductSchema;
